// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".space_group_items{margin-left:36%}.space_group_list{width:100%}.el-collapse{border-bottom:none}.last-group .answer-last-group{background-color:#f2f2f3}.answer-sub-group .points-item{background-color:#fcfcfc}.space_group_item.el-input.el-input--mini{width:48px}", ""]);
// Exports
module.exports = exports;
